import React, { useState, useEffect, useRef, useContext, FormEvent, ChangeEvent } from 'react';
import { Link, useParams } from 'react-router-dom';
import toastr from 'toastr';
import { toastTopRight } from '../../../components/Toastr/index';
import AppContext from '../../../context/AppContext';
import Axios from '../../../api/axios';
import {
	URL_GET_COURSE_BY_ID, URL_EDIT_COURSE, URL_IMAGEKIT_AUTHENTICATION, BASE_URL,
} from '../../../api/apiUrls';
import PainelNavBar from '../../../components/PainelNavbar/PainelNavBar';
import IKUploadK from '../../../components/IKUpload/index';

// TODO: remover espaço em branco no início e final dos inputs

export default function EditCourse() {
	// eslint-disable-next-line
	// @ts-ignore
	toastr.options = toastTopRight;

	const { currentUser } = useContext(AppContext);

	const INITIAL_STATE = {
		nome: '',
		descricao: '',
		publicoAlvo: '',
		cargaHoraria: '',
		horario: '',
		facilitadoresDoConhecimento: '',
		idCurso: '',
		investimento: '',
		informacoesAdicionais: '',
		imagem: '',
		conteudo: '',
		modifiedBy: currentUser.idUser,
	};

	const [inputs, setInputs] = useState(INITIAL_STATE);

	const { id } = useParams();

	const [isButtonDisabled, setIsButtonDisabled] = useState(true);

	const [isLoading, setLoading] = useState(true);

	const [hasNewImage, setHasNewImage] = useState(false);

	const childCompRef = useRef();

	useEffect(() => {
		setLoading(true);
		const getListaDeCursos = async () => {
			await Axios.get(`${URL_GET_COURSE_BY_ID}/${id}`)
				.then((response) => setInputs(response.data[0]))
				.catch((error) => {
					toastr.error(`${error.message} - Entre em contato com o Administrador`);
				});
			setLoading(false);
		};
		getListaDeCursos();
	}, []);

	useEffect(() => {
		setInputs((prevState) => ({ ...prevState, nameNewImage: inputs.idCurso }));
	}, [hasNewImage]);

	const thereIsImageInDB = () => {
		if (inputs.imagem) {
			setInputs((prevState) => ({ ...prevState, nameNewImage: inputs.idCurso }));
		}
	};

	useEffect(() => {
		thereIsImageInDB();
	}, [inputs.nome, isLoading]);

	const validateRequiredFormInputs = () => {
		const inputsToValidate = [inputs.nome, inputs.investimento, inputs.conteudo];
		setIsButtonDisabled(inputsToValidate.some((input) => input.length === 0));
	};

	const handleFormInputs = ({ target }: ChangeEvent<HTMLInputElement>) => {
		setInputs((prevState) => ({ ...prevState, [target.name]: target.value }));
		validateRequiredFormInputs();
	};

	const updateCourseOnDataBase = async () => {
		await Axios.put(URL_EDIT_COURSE, inputs)
			.then(async () => {
				// eslint-disable-next-line
				// @ts-ignore
				if (hasNewImage) await childCompRef.current.uploadFile();
				await Axios.get(`${URL_GET_COURSE_BY_ID}/${id}`)
					.then((response) => setInputs(response.data[0]))
					.catch((error) => { console.log(error); });
				toastr.success('Alterações salvas com sucesso!');
				setIsButtonDisabled(true);
			})
			.catch((error) => {
				toastr.error(`Um erro aconteceu. Tente novamente.${error}`);
			});
		setLoading(false);
	};

	const updateCourse = async (event: FormEvent) => {
		setLoading(true);
		event.preventDefault();
		await updateCourseOnDataBase();
	};

	return (
		<>
			<header className="mb-4">
				<PainelNavBar />
				<nav className="container bg-light rounded-3 shadow-sm" aria-label="breadcrumb" style={{ marginTop: '100px' }}>
					<ol className="breadcrumb p-2">
						<span className="me-2 text-muted">Você está em:</span>
						<li className="breadcrumb-item">
							<Link to="/panel">
								<i className="fa-solid fa-gear me-2" />
								Painel
							</Link>
						</li>
						<li className="breadcrumb-item">
							<Link to="/panel/course">
								<i className="fa-solid fa-list me-2" />
								Lista de Cursos
							</Link>
						</li>
						<li className="breadcrumb-item active">
							<Link to={`/panel/course/edit/${id}`}>
								<i className="fa-regular fa-pen-to-square me-2" />
								Editar Curso
							</Link>
						</li>
					</ol>
				</nav>
			</header>
			<section className="container">
				<form onSubmit={updateCourse} className="row justify-content-center">
					<div className="col-12 col-lg-6">
						<div className="row p-md-2">
							<label htmlFor="nome" className="form-label col-lg-12 my-2">
								<strong>Nome</strong>
								<span style={{ color: 'red' }}> *</span>
								<input
									name="nome"
									type="text"
									className="form-control"
									placeholder="Nome do curso"
									value={isLoading ? 'Carregando...' : inputs.nome}
									onChange={handleFormInputs}
									disabled={isLoading}
									required
								/>
							</label>
							<label htmlFor="descricao" className="form-label col-lg-12 my-2">
								<strong>Descrição</strong>
								<textarea
									name="descricao"
									className="form-control"
									placeholder="Descrição do curso"
									value={isLoading ? 'Carregando...' : inputs.descricao}
									style={{ resize: 'none' }}
									rows={4}
									onChange={handleFormInputs as any} // eslint-disable-line
									disabled={isLoading}
								/>
							</label>
							<label htmlFor="publicoAlvo" className="form-label col-lg-12 my-2">
								<strong>Público Alvo</strong>
								<input
									name="publicoAlvo"
									type="text"
									className="form-control"
									placeholder="Qual é o público alvo?"
									value={isLoading ? 'Carregando...' : inputs.publicoAlvo}
									onChange={handleFormInputs}
									disabled={isLoading}
								/>
							</label>
							<label htmlFor="cargaHoraria" className="form-label col-lg-12 my-2">
								<strong>Carga Horária</strong>
								<input
									name="cargaHoraria"
									type="text"
									className="form-control"
									placeholder="Carga Horária"
									value={isLoading ? 'Carregando...' : inputs.cargaHoraria}
									onChange={handleFormInputs}
									disabled={isLoading}
								/>
							</label>
							<label htmlFor="horario" className="form-label col-lg-12 my-2">
								<strong>Horário</strong>
								<input
									name="horario"
									type="text"
									className="form-control"
									placeholder="Horário"
									value={isLoading ? 'Carregando...' : inputs.horario}
									onChange={handleFormInputs}
									disabled={isLoading}
								/>
							</label>
							{inputs.imagem ? (
								<div className="col-lg-12 my-2">
									<div className="row align-items-center">
										<div className="col-12 col-lg-5 text-start" style={{ height: '210px' }}>
											<strong>Imagem</strong>
											<div className="border rounded-3 p-3">
												<img
													src={`https://ik.imagekit.io/xwugtefge/konfisio-site/courses/${inputs.imagem}?v=${Date.now()}`}
													alt={inputs.nome}
													className="img-fluid shadow-sm rounded-3 mx-auto d-block"
													style={{ maxHeight: '100px' }}
												/>
												<button
													type="button"
													className="mx-auto d-block btn btn-sm btn-outline-secondary mx-2 mt-3"
													onClick={() => { setInputs({ ...inputs, imagem: '' }); }}
												>
													Alterar imagem
												</button>
											</div>
										</div>
										<label htmlFor="investimento" className="form-label col-lg-7 my-2">
											<strong>Investimento</strong>
											<span style={{ color: 'red' }}> *</span>
											<textarea
												name="investimento"
												className="form-control"
												placeholder="Investimento"
												value={isLoading ? 'Carregando...' : inputs.investimento}
												onChange={handleFormInputs as any} // eslint-disable-line
												style={{ resize: 'none', height: '180px' }}
												rows={4}
												disabled={isLoading}
												required
											/>
										</label>
									</div>
								</div>
							) : (
								<>
									<div className="form-label col-lg-12 my-2">
										<strong>Imagem</strong>
										<IKUploadK
											// eslint-disable-next-line
											// @ts-ignore
											fileName={inputs.nameNewImage}
											tags={[inputs.nome]}
											useUniqueFileName={false}
											folder="/konfisio-site/courses"
											publicKey="public_JdnEOcQ+bNlV9WYwU8XtZgSJj7Y="
											urlEndpoint="https://ik.imagekit.io/xwugtefge"
											authenticationEndpoint={`${BASE_URL}${URL_IMAGEKIT_AUTHENTICATION}`}
											onChangeFunction={[setHasNewImage, hasNewImage]}
											setDadComponentStateImage={() => { }} // eslint-disable-line
											disabled={isLoading}
											ref={childCompRef}
										/>
									</div>
									<label htmlFor="investimento" className="form-label col-lg-12 my-2">
										<strong>Investimento</strong>
										<span style={{ color: 'red' }}> *</span>
										<textarea
											name="investimento"
											className="form-control"
											placeholder="Investimento"
											value={isLoading ? 'Carregando...' : inputs.investimento}
											style={{ resize: 'none' }}
											rows={3}
											onChange={handleFormInputs as any} // eslint-disable-line
											disabled={isLoading}
											required
										/>
									</label>
								</>
							)}
						</div>
					</div>
					<div className="col-12 col-lg-6">
						<div className="row p-md-2">
							<label htmlFor="facilitadoresDoConhecimento" className="form-label col-lg-12 my-2">
								<strong>Facilitadores do Conhecimento</strong>
								<textarea
									name="facilitadoresDoConhecimento"
									className="form-control"
									placeholder="Facilitadores do Conhecimento"
									value={isLoading ? 'Carregando...' : inputs.facilitadoresDoConhecimento}
									style={{ resize: 'none' }}
									rows={3}
									onChange={handleFormInputs as any} // eslint-disable-line
									disabled={isLoading}
								/>
							</label>
							<label htmlFor="conteudo" className="form-labe col-lg-12 my-2">
								<strong>Conteúdo</strong>
								<span style={{ color: 'red' }}> *</span>
								<textarea
									name="conteudo"
									className="form-control"
									placeholder="Conteúdo do curso"
									value={isLoading ? 'Carregando...' : inputs.conteudo}
									style={inputs.imagem ? { resize: 'none', height: '397px' } : { resize: 'none', height: '375px' }}
									onChange={handleFormInputs as any} // eslint-disable-line
									disabled={isLoading}
									required
								/>
							</label>
							<label htmlFor="informacoesAdicionais" className="form-label col-lg-12 my-2">
								<strong>Informações Adicionais</strong>
								<textarea
									name="informacoesAdicionais"
									className="form-control"
									placeholder="Informações que não se enquadram nos outros campos"
									value={isLoading ? 'Carregando...' : inputs.informacoesAdicionais}
									style={{ resize: 'none' }}
									rows={3}
									onChange={handleFormInputs as any} // eslint-disable-line
									disabled={isLoading}
								/>
							</label>
						</div>
					</div>
					<div className="col-12 col-lg-6 text-center">
						{isLoading
							? (
								<button type="submit" className="btn btn-md btn-primary col-12 col-lg-6 mx-auto mt-3" disabled>
									<span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
									Salvando...
								</button>
							)
							: (
								<button
									type="submit"
									className="btn btn-md btn-primary col-12 col-lg-6 mx-auto mt-3"
									disabled={isButtonDisabled}
								>
									<i className="fa-regular fa-floppy-disk me-2" />
									Salvar Curso
								</button>
							)}
						<br />
						<span style={{ color: 'red', fontSize: '14px' }}>* Informações obrigatórias</span>
					</div>
				</form>
			</section>
		</>
	);
}
